import React, { useState } from 'react'
import { Drawer, Dropdown, Menu, Tabs } from 'antd'
import { Route, Switch, useHistory, Link, useParams } from 'react-router-dom'
import Receive from "../../components/reusable/receive";
import { AiOutlineDown } from 'react-icons/ai'

import { useToggle, stringifyDate, useListData, usePet, normalize } from '../../modules'

const { TabPane } = Tabs

const Contact = ({ string = '', path, onClose }) => {
    const [chosen, setChosen] = useState([])
    const [selected, setSelected] = useState(null)
    const [index, setIndex] = useState(null)
    const [can, setCan] = useState(null)
    const [params, setParams] = useState({})

    const history = useHistory()
    const { id } = useParams()

    const [visible, toggleVisible] = useToggle(true)


    const close = () => {
        toggleVisible()
        // onClose()
        setTimeout(() => history.goBack(), 300)
    }

    const [{loading: cLoading, error: cError, data : oneContact}] = usePet('oneContact', { id}, {notify: true})

    return (
        <Drawer
            closable
            maskClosable
            visible={visible}
            onClose={close}
            width="40%">
            {/* <p className="font-extrabold text-3xl mb-0">Message #{messages?.id}</p> */}
            <p className="font-extrabold text-3xl mb-0">Contact # {id}</p>
            <div className="flex justify-between items-center">
                <span>
                    {/* <p className="text-gray-500 text-xs italic mb-0">Sent by { messages[0]?.createdBy } on { stringifyDate(invoice?.date) }</p> */}
                    {/* <div className="text-yellow-500 text-xs italic mb-0">Add message status here{ invoice?.status }</div> */}
                </span>
            </div>
            <Tabs className="mt-0">
                <TabPane key="0" tab="Contact Details">
                    <Receive error={null} loading={false} progress>
                        {oneContact ? (
                            <div className="flex flex-col pr-3 py-3">
                                <p className="font-semibold text-lg mb-2">Name:</p>
                                <p>{oneContact?.name}</p>
                                <p className="font-semibold text-lg mb-2">Phone No:</p>
                                <p>{oneContact?.phone}</p>
                                <p className="font-semibold text-lg mb-2">Email Address:</p>
                                <p>{oneContact?.email}</p>
                            </div>
                        ) : (
                            <div className="w-full h-16 flex items-center justify-center">
                                <p className="font-semibold text-base">
                                    Contact not found !
                                </p>
                            </div>
                        )}
                    </Receive>
                </TabPane>
            </Tabs>
            <Switch>
                <Route path={`${path}/contact/:id`}>
                </Route>
            </Switch>
        </Drawer>
    )
}

export default Contact